import React, {Component} from 'react';
import PropTypes from 'prop-types';

import subscriptionHOC from '@drivesally/sally-fw/lib/event/hoc/subscription.hoc.event';

import openedTicketCountForOpsUserApi from '../../api/openedTicketCountForOpsUser.api.crm';
import OpsUserCrmTicketBanner from '../../components/OpsUserCrmTicketBanner/OpsUserCrmTicketBanner';
import conversationMessageEvent from '../../events/conversationMessage.event.crm';
import ticketClosedEvent from '../../events/ticketClosed.event.crm';
import ticketCreatedEvent from '../../events/ticketCreated.event.crm';
import ticketUpdatedEvent from '../../events/ticketUpdated.event.crm';

import wait from '../../../libs/wait';

class OpsUserCrmTicketCountContainer extends Component {
  static propTypes = {
    inverted: PropTypes.bool,
    subscribe: PropTypes.func,
  };

  state = {
    count: 0,
  };

  componentDidMount() {
    this.mounted = true;
    this.fetchCount();
    this.poll();
    this.props.subscribe(
      ticketUpdatedEvent.subscribe(this.fetchCount),
      ticketCreatedEvent.subscribe(this.fetchCount),
      ticketClosedEvent.subscribe(this.fetchCount),
      conversationMessageEvent.subscribe(this.fetchCount)
    );
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  fetchCount = async () => {
    try {
      const {count = 0} = await openedTicketCountForOpsUserApi();
      if (!this.mounted) return;
      this.setState({count});
    } catch (error) {
      if (!this.mounted) return;
      this.setState({count: 0});
    }
  };

  poll = async () => {
    await wait(30000);
    if (!this.mounted) return;
    await this.fetchCount();
    this.poll();
  };

  render() {
    const {count} = this.state;
    const {inverted} = this.props;

    return <OpsUserCrmTicketBanner count={count} inverted={inverted} />;
  }
}

export default subscriptionHOC(OpsUserCrmTicketCountContainer);
